import gsap from "gsap";

const animateHamburger = () => {
    const els = Array.from(document.getElementsByClassName('hamburger-menu'));

    const submenu = document.getElementById('submenu');
    const dmcLogo = document.getElementsByClassName('dmc-logo');

    const hamburgerBarOne = document.getElementsByClassName('hamburger-bar-one');
    const hamburgerBarTwo = document.getElementsByClassName('hamburger-bar-two');
    const hamburgerBarThree = document.getElementsByClassName('hamburger-bar-three');

    const tl = gsap.timeline({paused: true, onReverseComplete: function() {
            $('#submenu').removeClass('submenu--toggled');
        }
    });

        tl.to(hamburgerBarOne, {duration: 0.2, ease:"circ", top: '50%'})
            .to(hamburgerBarThree, {duration: 0.2, ease:"circ", top: '50%'}, "<")
            .to(hamburgerBarThree, {rotateZ: "90deg", duration: 0.8, ease:"elastic"})
            .to(els, {rotateZ: "135deg", duration: 0.8, ease:"elastic"}, "<")
            .to(dmcLogo, {fill:"#ffff"}, "<")
            .to(hamburgerBarOne, {backgroundColor: "#ffffff"}, "<")
            .to(hamburgerBarTwo, {backgroundColor: "#ffffff"}, "<")
            .to(hamburgerBarThree, {backgroundColor: "#ffffff"}, "<")
            .from(submenu, {xPercent : -100}, 0)
            .from('.submenu-link', { y : 20, duration: 0.2, stagger :0.1, opacity: 0}, 0.3)
            .from('.submenu__icons a', { x : 20, duration: 0.2, stagger :0.1, opacity: 0}, 0.4)
        tl.set(submenu, {className:"submenu--toggled"}, 0)



    const submenuClose = document.getElementById('submenu-close');

    submenuClose.addEventListener('click', () => {
        els.forEach(el => el.classList.remove('hamburger-menu--toggled'));
        tl.reverse();
    });

    els.forEach(el => {
        el.onclick = () => {
            el.classList.add('hamburger-menu--toggled');

            if(tl.progress() === 1) {
                el.classList.remove('hamburger-menu--toggled');

                return tl.reverse();
            }

            tl.play();

        }
    });


}

document.addEventListener('readystatechange', () => {
    animateHamburger();
});
